import { render, staticRenderFns } from "./AgrupadorEmMassaV2.vue?vue&type=template&id=1b947964"
import script from "./AgrupadorEmMassaV2.vue?vue&type=script&lang=js"
export * from "./AgrupadorEmMassaV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b947964')) {
      api.createRecord('1b947964', component.options)
    } else {
      api.reload('1b947964', component.options)
    }
    module.hot.accept("./AgrupadorEmMassaV2.vue?vue&type=template&id=1b947964", function () {
      api.rerender('1b947964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AgrupadorEmMassaV2.vue"
export default component.exports